import type { FC } from 'react';

import {
  IconAlertCircleFilled,
  IconCircleCheckFilled,
  IconCircleMinus,
  IconCircleXFilled,
} from '@tabler/icons-react';
import { cn } from '@/lib/utils';

import type { EvaluationCheckpoint } from '@/types';

interface CheckpointStatusIconProps {
  checkpoint: EvaluationCheckpoint;
  size?: number;
}

const CheckpointStatusIcon: FC<CheckpointStatusIconProps> = ({
  checkpoint,
  size = 20,
}) => {
  const isException =
    checkpoint.hasException || checkpoint.status === 'EXCEPTION';

  const isNotScored = !checkpoint.metadata.isScored;

  const colorClass = isException
    ? 'text-gray-400'
    : isNotScored
    ? 'text-gray-300'
    : checkpoint.status === 'PASS'
    ? 'text-green-500'
    : 'text-red-500';

  if (checkpoint.status === 'FAIL') {
    return <IconCircleXFilled size={size} className={cn([colorClass])} />;
  }

  if (checkpoint.status === 'ERROR') {
    return <IconAlertCircleFilled size={size} className={cn([colorClass])} />;
  }

  if (checkpoint.status === 'PASS') {
    return <IconCircleCheckFilled size={size} className={cn([colorClass])} />;
  }

  return (
    <IconCircleMinus
      className={cn([
        'fill-gray-400 [&>path:first-child]:stroke-gray-400 [&>path:last-child]:stroke-white',
      ])}
      size={size}
    />
  );
};

export default CheckpointStatusIcon;